export default __webpack_public_path__ + "static/media/GR00020-pen_tip.4a97bcea.svg";